import { useState, useEffect } from 'react'

export type TimeOfDay = 'morning' | 'afternoon' | 'night'

const VALID: TimeOfDay[] = ['morning', 'afternoon', 'night']

function getTimeOfDay(hour: number): TimeOfDay {
  if (hour >= 6 && hour < 13) return 'morning'
  if (hour >= 13 && hour < 20) return 'afternoon'
  return 'night'
}

function getOverride(): TimeOfDay | null {
  if (typeof window === 'undefined') return null
  const param = new URLSearchParams(window.location.search).get('time')
  return param && VALID.includes(param as TimeOfDay) ? (param as TimeOfDay) : null
}

export function useTimeOfDay() {
  const [timeOfDay, setTimeOfDay] = useState<TimeOfDay>(
    () => getOverride() ?? getTimeOfDay(new Date().getHours()),
  )

  useEffect(() => {
    if (getOverride()) return
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay(new Date().getHours()))
    }, 60_000)
    return () => clearInterval(interval)
  }, [])

  return timeOfDay
}
